module.exports = __webpack_public_path__ + "media/flags/mx-da57f4af.svg";